import Vue from 'vue';
import Component from 'vue-class-component';
import * as i18next from 'i18next';
import * as utils from 'core/utils';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export default class SupportComponent extends Vue {
    gaParams: utils.GoogleAnalyticsParams = new utils.GoogleAnalyticsParams();

    mounted() {
        window.document.title = i18next.t('title_support');
    }

    onPhoneClick(phone: string) {
        (<any>this).$ga.sendPageview('/contacts/phone/click', 'Contacts / Phone / Click');
        (<any>this).$ga.sendEvent('contacts', 'btn.phone', 'contacts.btn.phone', this.gaParams);

        window.location.href = 'tel:' + phone;
    }

    onFaqClick() {
        (<any>this).$ga.sendEvent('zendesk', 'btn.help', 'zendesk.btn.help', this.gaParams);

        window.location.href = '/faq';
    }

    toSupport() {
        (<any>this).$ga.sendEvent('support.new', 'click', 'support.new.click');
        (<any>this).$ga.reachGoal('support.new.click');
        (<any>this).$ga.reachGoal('support.new.click.support');

        window.location.href = '/support/new';
    }
}
